import { JobPost } from "@/types/jobPost";
import React, { createContext, useContext } from "react";

interface JobPostContextProps {
  jobPost: JobPost | null;
  jobPostId: JobPost["id"] | undefined;
  setJobPostId: React.Dispatch<React.SetStateAction<JobPost["id"] | undefined>>;

  jobPostDetailsModalOpen: boolean;
  setJobPostDetailsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  closeJobPostDetailsModal: () => void;

  showAppliedModal: boolean;
  setShowAppliedModal: React.Dispatch<React.SetStateAction<boolean>>;
  recentlyAppliedJobId: JobPost["id"] | undefined;
  setRecentlyAppliedJobId: React.Dispatch<
    React.SetStateAction<JobPost["id"] | undefined>
  >;
  closeAppliedModal: () => void;

  flagJobPostModalOpen: boolean;
  setFlagJobPostModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  closeFlagJobPostModal: () => void;

  loading: boolean;
  error: string | null;
}

export const JobPostContext = createContext<JobPostContextProps | undefined>(
  undefined,
);

export function useJobPostContext() {
  const context = useContext(JobPostContext);

  if (!context) {
    throw new Error("useJobPostContext must be used within a JobPostProvider");
  }

  return context;
}
